export const aciAirplaneTripReturn = {
    iconName: 'airplane-trip-return',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 25 24' },
        path: {
            attr: {
                'fill-rule': 'evenodd',
                'clip-rule': 'evenodd',
                d: 'M14.91 6.873a.39.39 0 00-.191-.05H12.704L8.09 12.361a.566.566 0 01-.435.204H5.741a2.305 2.305 0 000 4.609H18.6a1.348 1.348 0 001.307-1.021l1.254-5.017a.39.39 0 00-.38-.485h-2.25l-.801 1.6a.566.566 0 01-.507.314h-3.827a.566.566 0 01-.506-.82l2.178-4.357a.388.388 0 00-.159-.515zm-.193-1.182a1.521 1.521 0 011.363 2.204l-1.768 3.537h2.562l.8-1.6a.566.566 0 01.506-.313h2.602a1.524 1.524 0 011.478 1.89l-1.255 5.018a2.48 2.48 0 01-2.405 1.879H5.741a3.436 3.436 0 110-6.874H7.39l4.614-5.537a.566.566 0 01.435-.204h2.278z',
                fill: 'currentColor',
            },
        },
    },
};
